import axios from "axios";
import Errores from "@/utils/Errores";

export const ApiRegistro = {
  registrarUsuario: async (registro, componente, gCaptchaToken) => {
    let reg = await axios
      .post(API.REGISTRO + "solicitud-cuenta", registro, gCaptchaToken)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        Errores.switchErrors(error, componente);
        return null;
      });
    return reg;
  },
  consultarEstado: async (id, componente) => {
    let cuenta = await axios
      .get(API.REGISTRO + "solicitud-cuenta/" + id + "/estado")
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        Errores.switchErrors(error, componente);
        return null;
      });
    return cuenta;
  }
};



// WEBPACK FOOTER //
// ./src/services/ApiRegistro.js